import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import {decode} from 'html-entities';
import ReactReadMoreReadLess from 'react-read-more-read-less'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import moment from "moment";
import { WorkshopListURL } from "../../../apis/urls";
import { $ } from "react-jquery-plugin";
import { message } from "antd";


const WorkshopView = () => {

    useEffect(() => {
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        EventViews();
    },[]
    );


    const { id } = useParams();
    const[ result,setResult ] = useState('');
    const[ sessions,setSessions ] = useState('');
    const[ description,setDescription ] = useState('');


    let navigate = useNavigate();


    const EventViews = ()=>{
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)

        const instance = axios.create({
            baseURL: WorkshopListURL+'/'+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {
            //console.log(res.data.data)
            setResult(res.data.data);
            setSessions(res.data.data.sessions)
            setDescription(ReactHtmlParser(desc))

          });

    }


    const DeleteEvent = () => {

        let r = window.confirm("Are you sure you want to delete this Event?");

        if(r == true){
            
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: WorkshopListURL+'/'+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{

                console.log("response", response.data.message)

                if(response.data.message === "failed"){
                    message.warning("Please delete session")
                }else{
                    navigate("/workshop")
                }
                            
            }).catch((error) =>{
                
                console.log('error',error.message)
            });
        }
    }



    const PublishStatusSubmit = () => {

        let token = "Bearer "+localStorage.getItem('token');
        const instance = axios.create({
            baseURL: WorkshopListURL+'/publish/'+id,
            timeout: 1000000,
            headers: {'authorization': token}
          });
          instance.patch('').then((response) =>{

            // window.location.reload();
            EventViews();

            // setPublish(response.data.publish_status)
            console.log("Success", response.data)
          }).catch((error) =>{   
            console.log('error',error.message)  
          });
    }


    const desc = decode(result.description);
    const decrypted_desc = ReactHtmlParser(desc)

    return(
       
        <div>
        <aside class="right-side areas">    
            <div class="content-area dash-contentss">







            <div className="page-title-wrpr">
                    <div className="page-title-left-column">
                        
                        <h2 className="page-title">Conference Manager - {decode(result.title)}</h2>
                    </div>
                    <div className="page-rightside-action-column">
                        
                        
                    </div>
                
                
                </div>


                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item"><Link to={"/workshop"}>Conference Manager</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Conference View {decode(result.title)}</li>                    
                    </ol>
                </nav>





            <div class="event-details-wrprs" style={{margin:"auto", maxWidth:'100%'}}>


            <div class="row">
        <div class="col-md-12">
          <div class="row event-basic-details-wrpr">
            <div class="col-md-6">
                {result.image?
                    <img src={result.image} width="" height="100%" alt="" />:
                    <div className="img-wrpr" />
                }
            </div>
            <div class="col-md-6 event-basic-details">
              <h2>{decode(result.title)}</h2>
                {decrypted_desc}

              <div class="date-time-seats">

                <div class="date-time">
                  <label>Date</label>
                  <div class="starttime-endtime">
                  <div class="starttime">{moment(result.start_date).format('ddd, MMM DD, YYYY')}</div>
                  <i class="icon-arrow-right1"></i>
                  <div class="endtime">{moment(result.end_date  ).format('ddd, MMM DD, YYYY')}</div>
                  </div>
                  
                </div>

                <div class="seats-wrpr">
                    <label>Time</label>
                    <div class="starttime-endtime">
                    <div class="starttime">{moment(result.start_date).format('LT')}</div>
                    <i class="icon-arrow-right1"></i>
                    <div class="endtime">{moment(result.end_date).format('LT')}</div>
                    </div>
                </div>

              </div>

              <hr style={{marginBottom:0}} />


              <div class="fees-wrpr">
                    <div class="member-fee">
                    <label>Location</label>
                    <div class="fee-content" style={{fontSize:'14px'}}>
                        {result.location}
                    </div>
                    </div>
                    <div class="member-fee">
                    <label>Address</label>
                    <div class="fee-content" style={{fontSize:'14px', maxWidth:'300px'}}>
                        {result.address}
                    </div>
                    </div>
                    <div class="member-fee">
                    <label>City</label>
                    <div class="fee-content" style={{fontSize:'14px'}}>
                        {result.city}
                    </div>
                    </div>
                    <div class="member-fee">
                    <label>State</label>
                    <div class="fee-content" style={{fontSize:'14px'}}>
                        {result.state}
                    </div>
                    </div>
                </div>

                <hr style={{marginBottom:0}} />

                <div class="fees-wrpr">
                    <div class="member-fee">
                    <label>zip Code</label>
                    <div class="fee-content" style={{fontSize:'14px'}}>
                        {result.zipcode}
                    </div>
                    </div>
                    <div class="member-fee">
                    <label>URL</label>
                    <div class="fee-content" style={{fontSize:'14px'}}>
                       <a href={result.link_url}>Click Here</a>
                    </div>
                    </div>
                    <div class="member-fee">
                    <label>Status</label>
                    <div style={{color:result.publish_status ==='PUBLISHED'?'green':'red', fontSize:'14px', width:'100px'}} class="fee-content">
                        {result.publish_status}
                    </div>
                    </div>
                    <div class="member-fee">
                    <label>Member School/ Non-Member School</label>
                    <div class="fee-content" style={{fontSize:'14px'}}>
                        {result.member_schools === "NO"? 'Non-Member School': 'Member School'}
                    </div>
                    </div>
                </div>

                <hr style={{marginBottom:0}} />


                <div class="fees-wrpr">
                    <div class="member-fee">
                    <label>Registration Deadline</label>
                    <div class="fee-content" style={{fontSize:'14px'}}>
                        {moment(result.registration_deadline).format('ddd, MMM DD, YYYY')}
                    </div>
                    </div>
                    <div class="member-fee">
                    <label>Participant Price</label>
                    <div class="fee-content" style={{fontSize:'14px'}}>
                        {result.participant_price}
                    </div>
                    </div>
                    <div class="member-fee">
                    <label>Non-Member Price</label>
                    <div style={{fontSize:'14px'}} class="fee-content">
                        {result.non_member_price}
                    </div>
                    </div>
                    <div class="member-fee">
                    <label>Late Registration Price</label>
                    <div class="fee-content" style={{fontSize:'14px'}}>
                        {result.late_registration_price}
                    </div>
                    </div>
                </div>

                <hr style={{marginBottom:0}} />


                <div class="fees-wrpr">
                    <div class="member-fee">
                    <label>No of Sessions</label>
                    <div class="fee-content" style={{fontSize:'14px'}}>
                        {sessions.length}
                    </div>
                    </div>
                </div>


                <div className="list-action-wrpr showicons roundicons-text" style={{marginTop:'2%'}}>
                    <div className="list-action-wrpr">

                    <Link to={"/update_workshop/"+result.id} data-toggle="tooltip" title="Edit"><i  class="edit icon-pencil3"></i><span>Update</span></Link>
                    <button onClick={DeleteEvent} style={{background:"transparent"}} data-toggle="tooltip" title="Delete"><a><i class="delete icon-close1"></i><span>Delete</span></a></button>
                    {result.publish_status ==='PUBLISHED'?                                    
                        <button onClick={PublishStatusSubmit} style={{background:"transparent"}} data-toggle="tooltip" title="Unpublish"><a><i class="delete icon-publish" style={{background:'#00eaad'}}></i><span>Unpublish</span></a></button>:
                        <button onClick={(e)=>{result.wno ===0 ?alert('Please add atleast one workshop'):PublishStatusSubmit(result.id)}} style={{background:"transparent"}} data-toggle="tooltip" title="Publish"><a><i class="delete icon-tick" style={{background:'#0069FF'}}></i><span>&nbsp;&nbsp;&nbsp;&nbsp;Publish&nbsp;&nbsp;&nbsp;&nbsp;</span></a></button>
                    }
                    </div>
                </div>

              




            </div>  
          </div>
        </div>
      </div>



                </div>
            </div>
        </aside>

    </div>








    )
}

export default WorkshopView;